import { computed } from 'vue'

export const useApp = () => {
  const { $gaApp } = useNuxtApp()

  const appWithHover = computed(() => $gaApp.stores.app.main.withHover)
  const appWithFocusKeyboard = computed(
    () => $gaApp.stores.app.main.withFocusKeyboard,
  )

  const appIsSSR = computed(() => $gaApp.services.app.main.isSSR)
  const appBaseUrl = computed(() => $gaApp.services.app.main.baseUrl)

  const isAddressBlockEnabled = computed(
    () => $gaApp.stores.app.common.toggle?.addressBlockEnabled,
  )

  return {
    appWithHover,
    appWithFocusKeyboard,

    appIsSSR,
    appBaseUrl,

    isAddressBlockEnabled,
  }
}
